import React from "react";

const GRID_SIZE = 48;

const TERCIOS = [1 / 3, 2 / 3];

const TEAM_MARK_PATH =
  "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z";

const BALL_GROOVE_PATH =
  "m-1643-1716 155 158m-550 2364c231 231 538 195 826 202m-524-2040c-491 351-610 1064-592 1060m1216-1008c-51 373 84 783 364 1220m-107-2289c157-157 466-267 873-329m-528 4112c-50 132-37 315-8 510m62-3883c282 32 792 74 1196 303m-404 2644c310 173 649 247 1060 180m-340-2008c-242 334-534 645-872 936m1109-2119c-111-207-296-375-499-534m1146 1281c100 3 197 44 290 141m-438 495c158 297 181 718 204 1140";

const BALL_SHADE_PATH =
  "m-1624-1700c243-153 498-303 856-424 141 117 253 307 372 492-288 275-562 544-724 756-274-25-410-2-740-60 3-244 84-499 236-764zm2904-40c271 248 537 498 724 788-55 262-105 553-180 704-234-35-536-125-820-200-138-357-231-625-340-924 210-156 417-296 616-368zm-3273 3033a2376 2376 0 0 1-378-1392l59-7c54 342 124 674 311 928-36 179-2 323 51 458zm1197-1125c365 60 717 120 1060 180 106 333 120 667 156 1000-263 218-625 287-944 420-372-240-523-508-736-768 122-281 257-561 464-832zm3013 678a2376 2376 0 0 1-925 1147l-116-5c84-127 114-297 118-488 232-111 464-463 696-772 86 30 159 72 227 118zm-2287 1527a2376 2376 0 0 1-993-251c199 74 367 143 542 83 53 75 176 134 451 168z";

const toUserUnit = (coord) => {
  if (coord === null || coord === undefined || Number.isNaN(Number(coord))) {
    return 0;
  }
  return (Number(coord) / GRID_SIZE) * 100;
};

const hasGeometry = (play = {}) => {
  const figures = Array.isArray(play.figureCoordinates)
    ? play.figureCoordinates
    : [];
  return (
    play.ballX !== undefined ||
    play.ballY !== undefined ||
    play.IdealPositionX !== undefined ||
    figures.length > 0
  );
};

function PlayDiagram({ play = {}, className = "", title = "" }) {
  if (!hasGeometry(play)) return null;

  const figures = Array.isArray(play.figureCoordinates)
    ? play.figureCoordinates
    : [];
  const ballX = toUserUnit(play.ballX);
  const ballY = toUserUnit(play.ballY);
  const idealX = toUserUnit(play.IdealPositionX);
  const idealY = toUserUnit(play.IdealPositionY);

  return (
    <div
      className={`relative h-full w-full overflow-hidden rounded-md bg-surface ${className}`}
    >
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 100 100"
        preserveAspectRatio="none"
        role="img"
        aria-label={title || "Jugada"}
        xmlns="http://www.w3.org/2000/svg"
        data-testid="play-diagram"
      >
        <rect width="100" height="100" fill="#1bfc08" />
        {TERCIOS.map((t) => {
          const y = t * 100;
          return (
            <line
              key={`h-${t}`}
              x1="0"
              y1={y}
              x2="100"
              y2={y}
              stroke="#fff"
              strokeWidth="2"
              strokeDasharray="4 4"
            />
          );
        })}
        {TERCIOS.map((t) => {
          const x = t * 100;
          return (
            <line
              key={`v-${t}`}
              x1={x}
              y1="0"
              x2={x}
              y2="100"
              stroke="#fff"
              strokeWidth="2"
              strokeDasharray="4 4"
            />
          );
        })}

        {figures.map((player, index) => (
          <circle
            key={`player-${index}`}
            cx={toUserUnit(player.xCoor)}
            cy={toUserUnit(player.yCoor)}
            r="6"
            fill={player.color || "#999"}
          />
        ))}

        <circle cx={idealX} cy={idealY} r="6" fill="green" />

        <g transform={`translate(50 50)`}>
          <svg
            x={-5}
            y={-5}
            width="10"
            height="10"
            viewBox="0 0 512 512"
            aria-hidden="true"
          >
            <path d={TEAM_MARK_PATH} fill={play.Team || "#ff0000"} />
          </svg>
        </g>

        <g transform={`translate(${ballX} ${ballY})`}>
          <svg
            x={-6}
            y={-6}
            width="12"
            height="12"
            viewBox="-2500 -2500 5000 5000"
            aria-hidden="true"
          >
            <g stroke="#000" strokeWidth="24">
              <circle fill="#fff" r="2376" />
              <path fill="none" d={BALL_GROOVE_PATH} />
            </g>
            <path fill="#000" d={BALL_SHADE_PATH} />
          </svg>
        </g>
      </svg>
    </div>
  );
}

export default PlayDiagram;